// GA4 prefers snake_case event / param names (same rule as dataLayer).
function toSnakeCase(value) {
  return String(value)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
}

function toGaParams(properties = {}) {
  const params = {};
  Object.keys(properties).forEach((key) => {
    const value = properties[key];
    if (value === undefined || value === null) return;
    const paramKey = toSnakeCase(key);
    if (!paramKey || paramKey === 'event') return;
    params[paramKey] = value;
  });
  return params;
}

function readGtag() {
  return typeof window !== 'undefined' && typeof window.gtag === 'function'
    ? window.gtag
    : null;
}

/**
 * Direct GA4 destination for the marketing catalog (M: events).
 * Does not go through GTM tags or RudderStack. Does not call gtag('set').
 * Traits reach GA4 as event params via createAnalytics merge on track.
 *
 * @type {import('./index').AnalyticsDestination}
 */
export const gaAdapter = {
  track(event, properties) {
    const gtag = readGtag();
    if (!gtag) return;
    gtag('event', toSnakeCase(event), toGaParams(properties));
  },

  identify() {
    // Intentionally empty: avoid gtag('set', 'user_properties').
    // createAnalytics copies traits onto each track payload for GA4 params.
  }
};
